import * as z from 'zod'
import { BookingCar, RentalService } from '~/shared/api'
import {
  DayEnum,
  RentalContractQuantityOfHoursEnum,
  RentalContractWorkScheduleEnum,
} from '~/shared/config/enums'
import {
  dateSchema,
  enumOptionSchema,
  uuidOptionSchema,
} from '~/shared/lib/schemas'
import { ApiModel, ToManyRelation, ToOneRelation } from './core'

const attributeSchema = z.object({
  workSchedule: enumOptionSchema(RentalContractWorkScheduleEnum),
  dayOff: enumOptionSchema(DayEnum).nullable(),
  quantityRentalPayments: enumOptionSchema(RentalContractQuantityOfHoursEnum),
  rentalServices: z
    .record(z.string(), z.boolean())
    .transform((rentalServices) =>
      Object.entries(rentalServices || {})
        .filter(([, isSelected]) => isSelected)
        .map(([id]) => id),
    ),
  promocode: z.string().optional().nullable(),
})

const relationsSchema = z.object({
  bookingCarId: uuidOptionSchema,
})

const schema = z
  .object({
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)
  .merge(relationsSchema)

export type RentalContactCreationRequestAttributes = z.infer<typeof schema>

export class RentalContactCreationRequest extends ApiModel<
  typeof schema,
  RentalContactCreationRequestAttributes
> {
  static jsonApiType = 'rental-contract-creation-requests'

  static schema = schema

  bookingCar(): ToOneRelation<BookingCar, this> {
    return this.hasOne(BookingCar)
  }
  getBookingCar(): BookingCar {
    return this.getRelation('bookingCar')
  }
  setBookingCar(id: UniqueId) {
    const bookingCar = new BookingCar()
    bookingCar.setApiId(id)
    this.setRelation('bookingCar', bookingCar)
  }

  rentalServices(): ToManyRelation<RentalService, this> {
    return this.hasMany(RentalService)
  }
  getRentalServices(): RentalService[] {
    return this.getRelation('rentalServices') ?? []
  }
}
